type Task<T> = () => Promise<T>;

export type TemplateReorderQueue = {
  enqueueByKey: <T>(key: string, task: Task<T>) => Promise<T>;
};

export function createTemplateReorderQueue(): TemplateReorderQueue {
  const tails = new Map<string, Promise<unknown>>();

  function enqueueByKey<T>(key: string, task: Task<T>): Promise<T> {
    const previousTail = tails.get(key) ?? Promise.resolve();

    const next = previousTail.then(task, task);

    const cleanup: Promise<unknown> = next.then(
      () => {
        if (tails.get(key) === cleanup) {
          tails.delete(key);
        }
      },
      () => {
        if (tails.get(key) === cleanup) {
          tails.delete(key);
        }
      }
    );

    tails.set(key, cleanup);

    return next;
  }

  return { enqueueByKey };
}
